import { render, staticRenderFns } from "./teaCertificate.vue?vue&type=template&id=18f81c52"
import script from "./teaCertificate.vue?vue&type=script&lang=js"
export * from "./teaCertificate.vue?vue&type=script&lang=js"
import style0 from "./teaCertificate.vue?vue&type=style&index=0&id=18f81c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports